import script from "./GgmsPhoneTelInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsPhoneTelInput.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsPhoneTelInput.vue?vue&type=style&index=0&id=b4a2fd6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4a2fd6a"]])

export default __exports__